export const EXTERNAL_ICON_CLASSNAME = 'SideNavigation__external-icon';
export const ANALYTICS_TYPES = {
  SIDENAVIGATION_TOOL_CLICK: 'prodex.side_navigation.tool.click',
  SIDENAVIGATION_EXPANDCOLLAPSE_CLICK: 'prodex.side_navigation.expand_collapse.click'
};
//# sourceMappingURL=consts.js.map